module.exports = __webpack_public_path__ + "img/img14.40d5e486.svg";